/* eslint-disable import/prefer-default-export */
export const DARKMODE_COOKIE_KEY = "reku-darkmode"
